var map = {
	"./cny-flower.png": 2614,
	"./paper.png": 2615,
	"./prize-1-bm.webp": 2616,
	"./prize-1-cn.webp": 2617,
	"./prize-1.webp": 2618,
	"./prize-2-bm.webp": 2619,
	"./prize-2-cn.webp": 2620,
	"./prize-2.webp": 2621,
	"./prize-3-bm.webp": 2622,
	"./prize-3-cn.webp": 2623,
	"./prize-3.webp": 2624,
	"./prize-4-bm.webp": 2625,
	"./prize-4-cn.webp": 2626,
	"./prize-4.webp": 2627,
	"./prize-5-bm.webp": 2628,
	"./prize-5-cn.webp": 2629,
	"./prize-5.webp": 2630,
	"./prize-6-bm.webp": 2631,
	"./prize-6-cn.webp": 2632,
	"./prize-6.webp": 2633,
	"./star.svg": 2634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 998;